<template>
  <!-- <div class="draw-dialog-wrapper"> -->
    <el-dialog
      title="抽签设置"
      :visible.sync="dialogVisible"
      :append-to-body="true"
      :modal-append-to-body="true"
      custom-class="draw-dialog"
      width="1200px"
      :destroy-on-close="true"
      @closed="handleClose"
    >
      <div class="dialog-content-wrapper" v-loading="loading">
        <div class="content-left">
          <span class="sz">设置</span>
          <!-- 抽过签显示抽奖池 -->
          <div class="draw-company-wrapper" v-if="isDraw">
            <div class="draw-company">
              <span
                class="draw-item"
                :title="item.tbdwName"
                v-for="(item, index) in isChoose
                  ? checkedCompanyLists
                  : chooseCompanyLists"
                :key="index"
                >{{ item.tbdwName }}</span
              >
            </div>
          </div>
          <!-- 没抽过签显示公司 -->
          <div v-else class="company-wrapper">
            <div class="commany-num-box">
              <div class="num-box" v-if="!isDraw">
                <div class="star-input">
                  <span class="star">*</span>请设置抽取家数
                  <el-input-number
                    v-model="chooseCompanyCount"
                    @change="changeChooseCompanyCount"
                    :min="1"
                    :controls="false"
                  ></el-input-number
                  >家
                </div>
              </div>
            </div>
            <div class="choose-company">
              <!--  可选企业 -->
              <div v-if="isChoose" class="can-choose-company">
                <el-checkbox
                  :indeterminate="isIndeterminate"
                  v-model="checkAll"
                  @change="handleCheckAllChange"
                  >全选</el-checkbox
                >
                <div style="margin: 15px 0"></div>
                <el-checkbox-group
                  v-model="checkedCompany"
                  @change="handleCheckedCitiesChange"
                >
                  <el-checkbox
                    v-for="city in chooseCompanyLists"
                    :label="city.tbdwId"
                    :key="city.tbdwId"
                    >{{ city.tbdwName }}</el-checkbox
                  >
                </el-checkbox-group>
              </div>
              <!--  不可选企业 -->
              <div v-else class="no-choose-company">
                <span
                  class="company-item"
                  :title="item.tbdwName"
                  v-for="(item, index) in chooseCompanyLists"
                  :key="index"
                  >{{ item.tbdwName }}</span
                >
              </div>
            </div>
            <el-button v-if="!isDraw" type="primary" @click="joinDrawChi"
              >加入抽签池</el-button
            >
          </div>
        </div>
        <div class="arrow">
          <img src="../../assets/images/arrow_draw_dialog.png" alt="" />
        </div>
        <div class="content-right">
          <span class="cqc">抽签池</span>
          <div v-if="step === 2 || step === 3" class="cqc-ball-wrapper">
            <span class="cqc-title"
              >从{{
                isChoose
                  ? checkedCompanyLists.length
                  : chooseCompanyLists.length
              }}家单位中抽取{{ chooseCompanyCount }}家</span
            >
            <div class="number-pond-wrapper">
              <div v-if="step === 3" class="drawed-list">
                <div
                  v-for="(item, index) in drawedCompanyLists"
                  :key="index"
                  class="drawed-item"
                >
                  {{ item.tbdwName }}
                </div>
              </div>
              <number-pond :isDraw="isDraw" ref="numberPond" />
            </div>
          </div>
          <div v-else-if="step === 1" class="cqc-wrapper">
            <span class="cqc-title"
              >从{{
                isChoose
                  ? checkedCompanyLists.length
                  : chooseCompanyLists.length
              }}家单位中抽取{{ chooseCompanyCount }}家</span
            >
            <div class="cqc-company-list">
              <div class="cqc-box">
                <div
                  class="cqc-item"
                  :title="item.tbdwName"
                  v-for="(item, index) in isChoose
                    ? checkedCompanyLists
                    : chooseCompanyLists"
                  :key="index"
                >
                  <span class="cqc-item-text">{{ item.tbdwName }}</span>
                  <img
                    @click="deleteChooseCompany(item.tbdwId)"
                    v-if="isChoose"
                    class="el-icon-error"
                    src="../../assets/images/delete_draw_dialog.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
          <div v-else-if="step === 0" class="cqc-tips">
            请确认并点击加入抽签池按钮~
          </div>

          <div class="draw-btn-wrapper">
            <el-button style="z-index: 999;" :disabled="step !== 1" type="primary" @click="startDraw"
              >开始抽签</el-button
            >
            <el-button
              style="z-index: 999;"
              :loading="stopDrawLoading"
              :disabled="step !== 2"
              type="primary"
              @click="endDraw"
              >停止抽签</el-button
            >
            <el-button
              style="z-index: 999;"
              :disabled="step !== 3"
              type="primary"
              @click="consoleDrawResult"
              >打印抽签结果表</el-button
            >
          </div>
        </div>
      </div>
    </el-dialog>
  <!-- </div> -->
</template>

<script>
import NumberPond from "../NumberPond/index.vue";
export default {
  name: "DrawDialog",
  components: { NumberPond },
  data() {
    return {
      isDraw: false, // 抽过签没
      isChoose: false, // 可选不可选企业
      dialogVisible: true,
      chooseCompanyCount: 1, // 选中公司的数量
      chooseCompanyLists: [
        // 公司列表
      ],
      checkAll: false, // 是否全选
      checkedCompany: [], // 选中可选公司的集合
      isIndeterminate: true, //
      step: 0, // 0（初始状态） 1（加入抽签池） 2（开始抽签） 3（结束抽签）
      drawedCompanyLists: [],
      stopDrawLoading: false, // 停止抽签按钮loading
      loading: true,
      checkedCompanyLists: [],
    };
  },
  mounted() {
    this.fetchDrawDetail();
  },

  computed: {
    // checkedCompanyLists() {
    //   console.log(this.checkedCompany, "this.checkedCompany");
    //   return this.chooseCompanyLists.filter((item) =>
    //     this.checkedCompany.includes(item)
    //   );
    // },
  },

  watch: {
    checkedCompany(val) {
      this.checkedCompanyLists = this.chooseCompanyLists.filter((item) =>
        this.checkedCompany.includes(item.tbdwId)
      );
    },
  },

  methods: {
    handleClose() {
      this.$emit("onCloseDialog")
      this.dialogVisible = false;
      this.step = 0
      this.checkedCompany = []
      this.chooseCompanyCount = 1
    },
    async fetchDrawDetail() {
      const res = await this.$api.getDrawDetail();
      if (res.data.meta.success) {
        const {
          isSelect = false,
          zqRecordList = [],
          drawRecordList = [],
        } = res?.data?.data || {};
        this.isChoose = isSelect;
        this.isDraw = zqRecordList?.length ? true : false;
        this.step = zqRecordList?.length ? 3 : 0;
        this.chooseCompanyLists = drawRecordList;
        this.drawedCompanyLists = zqRecordList;
        this.chooseCompanyCount = zqRecordList?.length || 1;
        if (this.isChoose) {
          this.checkedCompanyLists = drawRecordList;
        }
      } else {
        this.$message({
          type: "error",
          message: res.data.meta.message || "请求失败，请稍后重试~",
        });
      }
      this.loading = false;
    },
    changeChooseCompanyCount(value) {
      console.log(value);
    },
    handleCheckAllChange(val) {
      const checkedCompanyLists = this.chooseCompanyLists.map(
        (item) => item.tbdwId
      );
      this.checkedCompany = val ? checkedCompanyLists : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.chooseCompanyLists.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.chooseCompanyLists.length;
    },
    joinDrawChi() {
      if (this.chooseCompanyCount) {
        let chooseCompanyLength = this.chooseCompanyLists.length;
        if (this.isChoose) {
          if (this.chooseCompanyCount > 1) {
            return this.$message({
              message: "抽签企业不能大于1~",
              type: "warning",
            });
          }
          chooseCompanyLength = this.checkedCompany.length;
          if (!this.checkedCompany.length) {
            return this.$message({
              message: "请选择抽签企业~",
              type: "warning",
            });
          }
        }
        if (this.chooseCompanyCount < chooseCompanyLength) {
          this.step = 1;
        } else {
          this.$message({
            message: "公司列表数要大于抽取家数~",
            type: "warning",
          });
        }
      } else {
        this.$message({
          message: "请设置抽取家数~",
          type: "warning",
        });
      }
    },
    startDraw() {
      if (
        this.isChoose &&
        this.chooseCompanyCount > this.checkedCompanyLists?.length
      ) {
        this.$message({
          message: "抽取家数不应大于公司列表数~",
          type: "warning",
        });
      } else {
        this.step = 2;
      }
    },
    async endDraw() {
      this.stopDrawLoading = true;
      this.$refs.numberPond.speed();
      const params = {
        drawCount: this.chooseCompanyCount,
        tbdwIds: this.isChoose ? this.checkedCompany : undefined,
      };
      const res = await this.$api.doDraw(params);
      if (res.data.meta.success) {
        this.step = 3;
        console.log(res, "doDraw");
        const { zqRecordList = [], isSelect } = res?.data?.data || {};
        this.drawedCompanyLists = zqRecordList || [];
        this.isDraw = isSelect;
        this.$emit("onDrawSuccess");
      } else {
        this.$message({
          type: "error",
          message: res.data.meta.message || "请求失败，请稍后重试~",
        });
      }
      this.stopDrawLoading = false;
    },
    async consoleDrawResult() {
      const res = await this.$api.printDrawReport();
      if (res?.status === 200) {
        let blob = new Blob([res.data], {
          type: "application/pdf",
        });
        let url = window.URL.createObjectURL(blob);
        window.open(url, "_blank");
      } else {
        this.$message({
          type: "error",
          message: res?.data?.meta?.message || "请求失败，请稍后重试~",
        });
      }
    },
    deleteChooseCompany(id) {
      this.checkedCompany = this.checkedCompany.filter((todo) => todo !== id);
    },
  },
};
</script>

<style lang="less" scoped>
.draw-dialog-wrapper {
  width: 1200px;
  height: 560px;
  margin: 0 auto;
  ::v-deep .draw-dialog {
    width: 1200px;
    height: 560px;
  }
}
.dialog-content-wrapper {
  width: 1150px;
  height: 460px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .content-left,
  .content-right {
    width: 550px;
    height: 460px;
    background: #ffffff;
    box-shadow: 0px 4px 10px 0px rgba(15, 108, 203, 0.1);
    border-radius: 0px 0px 0px 0px;
    padding: 16px 25px;
    .sz {
      color: #0060b2;
      font-size: 16px;
    }
  }
}
.company-wrapper {
  width: 500px;
  .commany-num-box {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 29px;
    margin-top: 15px;
    .num-box {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 16px;
      .star-input {
        display: flex;
        align-items: center;
      }
      .star {
        color: red;
      }
      ::v-deep .el-input-number {
        width: 42px;
        height: 30px;
        margin-left: 10px;
        margin-right: 20px;
        margin-top: -6px;
      }
      ::v-deep .el-input__inner {
        width: 42px;
        height: 30px;
        padding: 0;
      }
    }
  }
}
.choose-company {
  width: 500px;
  // height: 318px;
  height: 267px;
  background: rgba(15, 108, 203, 0.05);
  border-radius: 0px 0px 0px 0px;
  padding: 20px;
  margin-bottom: 26px;
}
.no-choose-company {
  width: 100%;
  // height: 100%;
  // overflow-y: scroll;
  font-size: 14px;
  color: #333333;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .company-item {
    display: inline-block;
    width: 90px;
    margin-right: 94px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-bottom: 23px;
  }
  .company-item:nth-child(3n) {
    margin-right: 0;
  }
}
.no-choose-company:after {
  content: "";
  width: 90px;
  display: block;
}
.can-choose-company {
  width: 100%;
  height: 100%;
  overflow: auto;
  font-size: 14px;
  color: #333333;
  ::v-deep .el-checkbox-group {
    display: flex;
    flex-direction: column;
    .el-checkbox {
      margin-bottom: 14px;
    }
  }
}
.draw-company {
  width: 100%;
  // height: 100%;
  // overflow-y: scroll;
  font-size: 14px;
  color: #333333;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .draw-item {
    display: inline-block;
    width: 90px;
    height: 20px;
    margin-right: 94px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-bottom: 23px;
  }
  .draw-item:nth-child(3n) {
    margin-right: 0;
    // text-align: right;
  }
  // .draw-item:nth-child(2n) {
  //   text-align: center;
  // }
}
.draw-company:after {
  content: "";
  width: 90px;
  display: block;
}
.draw-company-wrapper {
  width: 100%;
  height: 100%;
  overflow: auto;
  width: 500px;
  height: 376px;
  background: rgba(15, 108, 203, 0.05);
  border-radius: 0px 0px 0px 0px;
  padding: 21px;
  margin-top: 21px;
}
.cqc {
  color: #0060b2;
  font-size: 16px;
}
.cqc-tips {
  width: 500px;
  height: 296px;
  font-weight: 400;
  font-size: 16px;
  color: #666666;
  text-align: center;
  margin-top: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.draw-btn-wrapper {
  margin: 0 auto;
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 20px;
  z-index: 999;
}
.cqc-wrapper {
  margin-top: 7px;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .cqc-title {
    height: 22px;
    font-weight: 700;
    font-size: 14px;
    color: #0060b2;
    line-height: 22px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    margin-bottom: 20px;
  }
  .cqc-company-list {
    width: 100%;
    height: 296px;
    background: rgba(15, 108, 203, 0.05);
    border-radius: 0px 0px 0px 0px;
    padding: 30px 21px;
  }
  .cqc-box {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
  }
  .cqc-item {
    width: 100px;
    height: 20px;
    margin-right: 79px;
    margin-bottom: 23px;
    display: flex;
    .cqc-item-text {
      display: inline-block;
      height: 20px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 14px;
      color: #333333;
    }
    .el-icon-error {
      width: 16px;
      height: 16px;
      cursor: pointer;
    }
  }
  .cqc-item:nth-child(3n) {
    margin-right: 0;
  }
}
.cqc-ball-wrapper {
  margin-top: 7px;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .cqc-title {
    height: 22px;
    font-weight: 700;
    font-size: 14px;
    color: #0060b2;
    line-height: 22px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    margin-bottom: 20px;
  }
}
.number-pond-wrapper {
  width: 432px;
  height: 290px;
  display: flex;
  justify-content: center;
  position: relative;
  .drawed-list {
    width: 432px;
    height: 290px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
    flex-direction: column;
    .drawed-item {
      height: 36px;
      font-weight: 400;
      font-size: 36px;
      color: #0f6ccb;
      line-height: 36px;
      margin-bottom: 14px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      width: 100%;
      text-align: center;
    }
    .drawed-item:last-child {
      margin-bottom: 0;
    }
  }
}

::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #0060b2;
}
</style>
